// Angular
import { Injectable } from '@angular/core';
// RxJS
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of, forkJoin } from 'rxjs';
// NGRX
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Services
// State
import { AppState } from '../../../core/reducers';
import {
  AffiliationActionTypes,
  AffiliationsPageRequested,
  AffiliationsPageLoaded,
  AffiliationCreated,
  AffiliationDeleted,
  AffiliationUpdated,
  AffiliationOnServerCreated,
  AffiliationsActionToggleLoading,
  AffiliationsPageToggleLoading,
  ThrowError,
  ClearErrors,
  AffiliationOnServerUpdated,
  AffiliationsPageCancelled,
  AffiliationOnServerDeleted,
  // AffiliationStatusUpdated
} from '../_actions/affiliation.actions';
import { Router } from '@angular/router';
import { AffiliationsService } from '../_services/affiliation.service';

@Injectable()
export class AffiliationEffects {
  showPageLoadingDistpatcher = new AffiliationsPageToggleLoading({ isLoading: true });
  hidePageLoadingDistpatcher = new AffiliationsPageToggleLoading({ isLoading: false });
  showActionLoadingDistpatcher = new AffiliationsActionToggleLoading({ isLoading: true });
  hideActionLoadingDistpatcher = new AffiliationsActionToggleLoading({ isLoading: false });

  // done
  @Effect()
  loadAffiliationsPage$ = this.actions$.pipe(
    ofType<AffiliationsPageRequested>(AffiliationActionTypes.AffiliationsPageRequested),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showPageLoadingDistpatcher);
      const requestToServer = this.affiliation.getAffiliationsPage(payload.page);
      const lastQuery = of(payload.page);
      return forkJoin(requestToServer, lastQuery).pipe(
        catchError((error) => {
          return of([error]);
        }),
        map((response) => {
          if (response[0].error) {
            if (response[0].status === 401) {
              return response[0];
            } else if (response[0].status === 403) {
              this.router.navigateByUrl('/error/403');
              return new AffiliationsPageCancelled();
            } else {
              this.store.dispatch(new ThrowError({ error: response[0].error }));
              return new AffiliationsPageCancelled();
            }
          } else {
            const result = response[0];
            // tslint:disable-next-line:no-shadowed-variable
            const lastQuery: QueryParamsModel = response[1];
            this.store.dispatch(new ClearErrors());
            return new AffiliationsPageLoaded({
              affiliations: result.data,
              totalCount: result.count,
              page: lastQuery,
            });
          }
        }),
      );
    }),
  );

  @Effect()
  deleteAffiliation$ = this.actions$.pipe(
    ofType<AffiliationOnServerDeleted>(AffiliationActionTypes.AffiliationOnServerDeleted),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.affiliation.deleteAffiliation(payload.id).pipe(
        catchError((error) => {
          return of({ error });
        }),
        map(() => {
          this.store.dispatch(this.hideActionLoadingDistpatcher);
          return new AffiliationDeleted(payload);
        }),
      );
    }),
  );

  @Effect()
  updateAffiliation$ = this.actions$.pipe(
    ofType<AffiliationOnServerUpdated>(AffiliationActionTypes.AffiliationOnServerUpdated),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.affiliation.updateAffiliation(payload.affiliation).pipe(
        catchError((error) => {
          return of({ error });
        }),
        map((res) => {
          if (res.error) {
            return new ThrowError({ error: res.error });
          } else {
            this.store.dispatch(this.hideActionLoadingDistpatcher);
            this.store.dispatch(new ClearErrors());
            return new AffiliationUpdated(payload);
          }
        }),
      );
    }),
  );

  @Effect()
  createAffiliation$ = this.actions$.pipe(
    ofType<AffiliationOnServerCreated>(AffiliationActionTypes.AffiliationOnServerCreated),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.affiliation.createAffiliation(payload.affiliation).pipe(
        catchError((error) => {
          return of(error);
        }),
        map((res) => {
          if (res.status == 201) {
            this.store.dispatch(new ClearErrors());
            this.store.dispatch(this.hideActionLoadingDistpatcher);
            return new AffiliationCreated({ affiliation: res });
          } else {
            return new ThrowError({ error: res });
          }
        }),
      );
    }),
  );

  constructor(
    private actions$: Actions,
    private affiliation: AffiliationsService,
    private store: Store<AppState>,
    private router: Router,
  ) {}
}
